import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as c } from "react";
const v = ({
  title: l,
  titleId: h,
  ...o
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": h,
    ...o,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: h, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M652.363 511.04H318.24v154.325c0 50.389 1.237 83.349 3.776 98.901 2.453 15.595 8.853 27.157 19.093 34.709 10.24 7.531 29.611 11.307 58.304 11.307h16.469v21.717H128.01v-21.717h16.533c27.328 0 46.336-3.477 56.853-10.368 10.517-6.976 17.301-17.728 20.267-32.32 2.965-14.677 4.48-48.725 4.48-102.229V351.509c0-50.965-1.515-83.861-4.48-98.624-2.965-14.784-9.301-25.024-18.88-30.677-9.579-5.675-30.571-8.512-63.019-8.512h-11.755V192h287.872v21.696h-11.84c-31.083 0-51.541 2.624-61.269 7.787-9.813 5.227-16.32 14.891-19.605 29.035-3.349 14.165-4.928 47.808-4.928 100.992v126.976h334.123V351.51c0-50.965-1.429-83.861-4.267-98.624-2.837-14.784-9.088-25.024-18.667-30.677-9.579-5.675-30.571-8.512-63.019-8.512h-17.003v-21.696h291.221v21.696h-9.429c-31.445 0-52.053 2.624-61.781 7.787-9.813 5.227-16.341 14.891-19.605 29.035-3.349 14.165-4.928 47.808-4.928 100.992v313.856c0 50.389 1.152 83.349 3.477 98.901 2.389 15.595 8.704 27.157 19.157 34.709 10.325 7.531 29.845 11.307 58.539 11.307h14.571v21.717H549.407v-21.717h22.229c27.072 0 45.888-3.477 56.405-10.368 10.539-6.976 17.216-17.728 20.053-32.32 2.837-14.677 4.267-48.725 4.267-102.229V511.042zm239.125-228.427h-.576c-6.485 0-13.035 1.451-22.123 3.968l-29.589 8.661c-10.197 2.965-16.768 11.499-16.768 21.781 0 11.84 10.133 21.867 22.144 21.867 3.243 0 7.381-.981 8.619-1.28l13.461-3.477V476c0 13.696 11.136 24.832 24.832 24.832S916.32 489.696 916.32 476V307.467c0-13.717-11.136-24.853-24.832-24.853z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = c(v);
export {
  n as default
};
